import request from './request'

/**
 * 获取符合条件的文件瀑布流
 * 
 */
export function getFilePic(data){
    let url = "/api/File/GetSatisfyFileAsync";
    return request({
        url: url,
        method: "post",
        dataType: "json",
        data
    });
}

/**
 * 获取文件明细
 *  
 */
export function getFileDel(data){
    let url = "/api/File/GetFileDetailAsync";
    return request({
        url: url,
        method: "get",
        dataType: "json",
        params:data
    });
}


/**
 * 获取相似图片
 * 
 */
export function getSimlarPic(data){
    let url = "/api/File/GetSimlarFileListAsync";
    return request({
        url: url,
        method: "get",
        dataType: "json",
        params:data
    });
}

// 获取文件图片详情用于编辑——前端接口

export function GetFileForEdit(data){
    let url = "/api/File/GetFileForEditAsyncWeb";
    return request({
        url: url,
        method: "get",
        dataType: "json",
        params:data
    });
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/fileApi.js